import React, { useEffect } from 'react';
import { useAppSelector } from '../../../hooks/storeHooks';
import { formatDate } from '../../../utilities/dateHelpers';
import './ScanBarResult.scss';
import { IRodLiftStatusWellModel } from '../../../models/RodPumpWellStatus';

const ScanResultBar = () => {
  const themeMode = useAppSelector((state) => state.theme.mode);

  const rodliftwellstatusDataLoading = useAppSelector((state) => state.rodliftwellstatus.loading);
  const wellStatusData: IRodLiftStatusWellModel | undefined = useAppSelector((state) => state.rodliftwellstatus.data);
  const [lastGoodScan, setLastGoodScan] = React.useState(() =>
    Array.isArray(wellStatusData)
      ? wellStatusData.imageOverlayItems.find((item) => item.overlayField === 1)
      : undefined,
  );
  const [lastCommStatus, setLastCommStatus] = React.useState(() =>
    Array.isArray(wellStatusData)
      ? wellStatusData.imageOverlayItems.find((item) => item.overlayField === 3)
      : undefined,
  );

  useEffect(() => {
    setLastGoodScan(() => Array.isArray(wellStatusData?.imageOverlayItems) ? wellStatusData?.imageOverlayItems.find((item) => item.overlayField === 1) : undefined);
    setLastCommStatus(() => Array.isArray(wellStatusData?.imageOverlayItems) ? wellStatusData?.imageOverlayItems.find((item) => item.overlayField === 3) : undefined);
  }, [rodliftwellstatusDataLoading, wellStatusData]);

  const knownErrorKeywords = [
    'bad item',
    'commandnotsupported',
    'comtimeout',
    'crcerror',
    'error',
    'getopcode_6 failed',
    'illegal data address',
    'openport failed',
    'read registers exception',
    'rpcservunvl',
    'socket connect failed',
    'socketconn',
    'socketconnectfail',
    'timeout',
  ];

  const getStatusDisplay = (status?: string | null): { text: string; color: string } => {
    const lower = status?.toLowerCase() ?? '';

    if (!lower.trim()) return { text: '', color: 'text-gray-400' };

    const isKnownError = knownErrorKeywords.some((keyword) =>
      lower.includes(keyword)
    );
    if (isKnownError || lower.includes('timeout') || lower.includes('fail') || lower === 'error') {
      return { text: 'Error', color: 'text-red-400' };
    }
    if (lower === 'unknown') {
      return { text: 'Unknown', color: 'text-gray-400' };
    }
    return { text: status ?? '', color: 'text-green-400' };
  };
  const { text, color } = getStatusDisplay(lastCommStatus?.value);

  return (
    <div
      className={`fixed bottom-0 w-full ${themeMode === 'dark' ? 'theme-dark' : ''} border-t-[1px] z-[3] border-gray-300  text-sm text-white flex items-center gap-4 p-2 px-4 rounded`}
    >
      <div className='flex items-center gap-1'>
        <span className='last-scan-result'>Last scan result:</span>
        <span className={`font-semibold ${color}`}>{text}</span>
      </div>

      <div className='h-4 w-px bg-gray-600'></div>

      <div className='last-scan-time'>
        Scan time: <span className=''>{lastGoodScan?.value ? formatDate(lastGoodScan.value, true) : ''}</span>
      </div>
    </div>
  );
};

export default ScanResultBar;
